
export default {
  // Common
  "language": "Langue",
  "language_description": "Changer la langue utilisée dans toute l'application",
  "save_language": "Enregistrer la préférence de langue",
  "updating": "Mise à jour...",
  "return_home": "Retour à l'accueil",
  "sign_out": "Déconnexion",
  "error": "Erreur",
  "loading": "Chargement...",
  "cancel": "Annuler",
  "save": "Enregistrer",
  "edit": "Modifier",
  "delete": "Supprimer",
  "back": "Retour",
  "view_details": "Voir les détails",
  "not_applicable": "N/A",
  "invalid_date": "Date invalide",
  "name": "Nom",
  "qty": "Qté",
  "actions": "Actions",
  "sort_by": "Trier par",
  "filter_by": "Filtrer par",
  "ascending": "Croissant",
  "descending": "Décroissant",
  "date_added": "Date d'ajout",
  "retry": "Réessayer",
  "with": "avec",
  "or": "ou",
  "format": "Format",
  "username": "Nom d'utilisateur",
  "phone_number": "Numéro de téléphone",
  "email": "E-mail",
  "change": "Modifier",
  "save_changes": "Enregistrer les modifications",
};
